'use client';
import * as React from 'react';
import { createEventBus } from '@/shared/utils';
import { Profile } from '@/shared/i18n';
import { ProfileScreen, ProfileEventKeys, ProfileEvents } from '@/profile';
import { useAuth, useAuthStore } from '@/auth';
import { ProfileLoader } from 'src/modules/profile/ui/shared/module-loader';
import { useRouter } from 'next/navigation';
import { useFirebaseAuth } from '@/shared/hooks';

interface MeContainerProps {
  dict: Profile;
}

export function MeContainer({ dict }: MeContainerProps) {
  const profileEventBus = createEventBus<ProfileEvents>('profile-scope');
  const auth = useFirebaseAuth();
  const router = useRouter();
  const { logout } = useAuth();
  const { user, hydrated } = useAuthStore();

  const handleRedirect = React.useCallback((url: string) => router.push(url), [router]);

  React.useEffect(() => {
    if (hydrated && !user?.email) {
      handleRedirect('/auth/login');
    }

    if (user?.email) {
      profileEventBus.emit(ProfileEventKeys.profile.view, { email: user.email });
    }
    profileEventBus.on(ProfileEventKeys.redirect.to, handleRedirect);
    profileEventBus.on(ProfileEventKeys.profile.logout, logout);
    return () => {
      profileEventBus.off(ProfileEventKeys.redirect.to, handleRedirect);
      profileEventBus.off(ProfileEventKeys.profile.logout, logout);
    };
  }, [user?.email, hydrated, profileEventBus]);

  if (!user?.email || !auth) return <ProfileLoader key="profile-loader" />;

  return <ProfileScreen auth={auth} eventBus={profileEventBus} dict={dict} key="profile-screen" />;
}

export default MeContainer;
